<template>
	<div class="register">
		<div class="wrap">
			<el-form :model="ruleForm" :rules="editFormRules" ref="ruleForm" v-if="ruleForm_is" label-position="top">
				<div class="p1">{{$t('index_register.h1')}}</div>
				<div class="p2 cle"><span>{{$t('index_register.account')}}</span></div>
				<div class="input_yincang">
					<div class="">
						<input type="text" name="name">
						<input type="password" name="password">
					</div>
				</div>
				<el-row  class="neirong">
					<el-col :span="24">
						<el-form-item :label="$t('index_register.phone')" prop="tel" :error="errorMsg">
							<el-input v-model="ruleForm.tel" class="w100" @blur="tel_f_f" @focus="errorMsg=''" autocomplete="off" :placeholder="$t('header.input')">
								<el-button slot="append" @click="phone_code" :disabled="disabled">{{btntxt}}</el-button>
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item :label="$t('index_register.code')" prop="code">
							<el-input v-model="ruleForm.code" class="w100" autocomplete="off"  :placeholder="$t('header.input')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item :label="$t('index_register.password')" prop="password">
							<el-input v-model="ruleForm.password" class="w100" autocomplete="off" show-password :placeholder="$t('header.input')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item :label="$t('index_register.confirm_password')" prop="re_password">
							<el-input v-model="ruleForm.re_password" class="w100" autocomplete="off" show-password :placeholder="$t('header.input')"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<div class="p2 cle"><span>{{$t('index_register.profile')}}</span></div>
				<el-row  class="neirong">
					<el-col :span="24">
						<el-form-item :label="$t('index_register.name')" prop="name">
							<el-input v-model="ruleForm.name" class="w100"  autocomplete="off" :placeholder="$t('header.input')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item :label="$t('index_register.wechat')" prop="wechat_id">
							<el-input v-model="ruleForm.wechat_id" class="w100"  autocomplete="off" :placeholder="$t('header.input')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item :label="$t('index_register.email')" prop="email">
							<el-input v-model="ruleForm.email" class="w100" autocomplete="off"  :placeholder="$t('header.input')"></el-input>
							<p>请准确填写邮箱地址，购课后会发送确认信</p>
						</el-form-item>
					</el-col>
					<!-- <el-col :span="24">
						<el-form-item :label="$t('index_register.city')" prop="province">
							<el-input v-model="ruleForm.province" class="w100"  autocomplete="off" :placeholder="$t('header.input')"></el-input>
						</el-form-item>
					</el-col> -->
				</el-row>
				<el-row  class="neirong neirong_">
					<el-col :span="24" v-for="(item,index) in ruleForm.children" :key="index">
						<el-form-item :label="$t('index_register.namekid') +' '+(index+1) +' '+ $t('index_register.namekid_')">
							<el-row :gutter="10">
								<el-col :span="8">
									<el-form-item :label="$t('index_register.student_name_cn')" :prop="'children.'+index+'.name'" :rules="editFormRules.student_name_cn">
										<el-input v-model="item.name_cn" class="w100"  autocomplete="off" :placeholder="$t('header.input')"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<el-form-item :label="$t('index_register.student_name')" :prop="'children.'+index+'.name'" :rules="editFormRules.student_name">
										<el-input v-model="item.name" class="w100"  autocomplete="off" :placeholder="$t('header.input')"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<el-form-item :label="$t('index_register.login_user_name')" :prop="'children.'+index+'.login_user_name'">
										 <!-- :rules="editFormRules.login_user_name" -->
										<el-input v-model="item.login_user_name" class="w100"  autocomplete="off" :placeholder="$t('header.input')"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<el-form-item :label="$t('index_register.student_email')" :prop="'children.'+index+'.user_name'" >
										<!-- :rules="editFormRules.student_email" -->
										<el-input v-model="item.user_name" class="w100"  autocomplete="off" :placeholder="$t('header.input')"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<el-form-item :label="$t('index_register.password')" :prop="'children.'+index+'.password'">
										 <!-- :rules="editFormRules.password" -->
										<el-input v-model="item.password" class="w100" show-password autocomplete="off" :placeholder="$t('header.input')"></el-input>
									</el-form-item>
								</el-col>
								<!-- <el-col :span="8">
									<el-form-item :label="$t('index_register.adult')" :prop="'children.'+index+'.is_adult'" >
										<el-switch v-model="item.is_adult" :inactive-text="$t('index_register.inactive')" :active-text="$t('index_register.active')" :active-value="1" :inactive-value="0"></el-switch>
									</el-form-item>
								</el-col> -->
								<el-col :span="8">
									<el-form-item :label="$t('index_register.grade')" :prop="'children.'+index+'.grade'" :rules="editFormRules.grade">
										<el-select v-model="item.grade" class="w100" :placeholder="$t('header.input')">
											<el-option v-for="(item,index) in grade_list" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="Number(item.code)"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<el-form-item :label="$t('index_register.yearmonth')" :prop="'children.'+index+'.year_month'" :rules="editFormRules.year_month">
										<el-date-picker v-model="item.year_month" class="w100" @change="year_month_f(item.year_month,index)" value-format="yyyy-MM" type="month"></el-date-picker>
									</el-form-item>
								</el-col>
								<el-col class="line" :span="2" v-if="index!=0"><i class="el-icon-remove" @click="remove(index)"></i></el-col>
							</el-row>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<div class="tianj_anjian" @click="add">{{$t('index_register.addchild')}}</div>
					</el-col>
				</el-row>
				<div class="p2 cle"><span>{{$t('index_register.information')}}</span></div>
				<el-row  class="neirong">
					<el-col :span="24">
						<el-form-item :label="$t('index_register.address')" prop="referred_tel">
							<el-input v-model="ruleForm.referred_tel" class="w100"  autocomplete="off" :placeholder="$t('header.input')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="11">
						<el-form-item :label="$t('index_register.names')" prop="seller_id">
							<el-select v-model="ruleForm.seller_id" class="w100" :placeholder="$t('header.select')">
								<el-option v-for="(item,index) in seller" :key="index" autocomplete="off" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<div class="tijiao" @click="tijiao">{{$t('index_register.complete')}}</div>	
			</el-form>
		</div>
	</div>
</template>
<script>
import {countryCode} from '@/assets/js/countryCode'
export default {
	inject:['user_name_f'],
	computed: {
		rules(){
			return{
				tel: [{
					required: true,
					message: this.$t('header.input')+ this.$t('index_register.phone'),
					trigger: 'blur'
				},{
					pattern: /^1[34578]\d{9}$/,
					message:this.$t('teacher_apply.rules_phone_'),
					trigger:'blur'
				}],
				code: [{
					required: true,
					message: this.$t('header.input')+ this.$t('index_register.code'),
					trigger: 'blur'
				}],
				password: [{
					required: true,
					message: this.$t('header.input')+ this.$t('index_register.password'),
					trigger: 'blur'
				}],
				name: [{
					required: true,
					message: this.$t('header.input')+ this.$t('index_register.name'),
					trigger: 'blur'
				}],
				wechat_id: [{
					required: true,
					message: this.$t('header.input')+ this.$t('index_register.wechat'),
					trigger: 'blur'
				}],
				email: [{
						required: true,
						message: this.$t('header.input')+ this.$t('index_register.email'),
						trigger: 'blur'
					},
					{
						type: 'email', 
						message: this.$t('header.input')+ this.$t('index_register.email_'),
						trigger: ['blur', 'change']
					}
				],
				province: [{
					required: true,
					message: this.$t('header.input')+ this.$t('index_register.city'),
					trigger: 'blur'
				}],
				children_name: [{
					required: true,
					message: this.$t('header.input')+ this.$t('index_register.name'),
					trigger: 'blur'
				}],
				student_name: [{
					required: true,
					message: this.$t('header.input')+ this.$t('index_register.student_name'),
					trigger: 'blur'
				}],
				student_name_cn: [{
					required: true,
					message: this.$t('header.input')+ this.$t('index_register.student_name_cn'),
					trigger: 'blur'
				}],
				grade: [{
					required: true,
					message: this.$t('header.select')+ this.$t('index_register.grade'),
					trigger: 'change'
				}],
				year_month: [{
					required: true,
					message: this.$t('header.input')+ this.$t('index_register.yearmonth'),
					trigger: 'blur'
				}],
			}
		},
	},
	data() {
		const validatorEmail = (rule, value, callback) => {
			if (!value) {
				return callback(new Error(this.$t('header.input') + this.$t('index_register.password')));
			} else {
				if (value==this.ruleForm.password) {
					callback();
				} else {

					return callback(new Error(this.$t('index_register.thetwo')))
				}
			}
		};
		return {
			editFormRules: {
				re_password: [{
					required: true,
					validator: validatorEmail,
					trigger: 'blur'
				}],
			},
			month:'',
			ruleForm:{
				prefix:'86',
				tel:'',
				code:'',
				password:'',
				re_password:'',
				name:'',
				email:'',
				province:'',
				referred_tel:'',
				seller_id:'',
				children:[
					{
						name:'',
						name_cn:'',
						year_month:'',
						birthday_month:'',
						birthday_year:'',
						is_adult:0,
						user_name:'',
						grade:'',
					}
				],
				time_zone:'',
				time_country:'',
				seller_id:'',
			},
			ruleForm_is:false,
			seller:[],
			disabled:false,
			time:0,
			btntxt:'',
			countryCode:countryCode,
			grade_list:[],
			errorMsg:'',

		};
	},
	// 初始事件
	mounted: function () {
		this.btntxt=this.$t('index_register.phone_code');
		this.editFormRules=Object.assign(this.rules,this.editFormRules);
		this.ruleForm_is=true;
		this.config();

		var raf = localStorage.getItem('raf')||'';
		if (raf) {
			this.raf_f(raf);
		}
	},
	methods: {
		config(){
			var this_ = this;
			var url = "sellerList";
			this_.$post(url, {}).then(res => {
				this_.seller=res;
			}).catch(res => {})
			var url = "courseScreen";
			this_.$post(url, {},false).then((res) => {
				this_.grade_list=res.grade_list;
			})
		},
		tel_f_f(){
			var this_ = this;
			this_.$refs.ruleForm.validateField('tel',(valid) => {
				if (!valid) {
					var datas = {
						tel: this_.ruleForm.tel,
					};
					var url = "addUserHaveTel";
					this_.$post(url, datas,false).then(res => {
						this_.errorMsg=res;
					})
				}else{
					return false;
				}
			})

		},
		raf_f(raf){
			var this_ = this;
			var url = "raf2Email";
			var datas={
				raf:raf,
			}
			this_.$post(url,datas).then(res => {
				if (res) {
					this_.ruleForm.referred_tel=JSON.parse(JSON.stringify(res));
				}
			}).catch(res => {})
		},
		phone_code(){
			var this_ = this;
			this_.$refs.ruleForm.validateField('tel',(valid) => {
				if (!valid) {
					var datas = {
						tel: this_.ruleForm.tel,
						type:'tel'
					};
					var url = "sendCode";
					this_.$post(url, datas).then(res => {
						this_.time=60;
						this_.timer();
						this_.ruleForm.code='';
						this_.$message.success(this_.$t('index_register.Sent_successfully'));
					})
				}else{
					return false;
				}
			})
		},
		tijiao(ruleForm) {
			var this_ = this;
			this_.$refs.ruleForm.validate((valid) => {
				if (valid) {
					var children=this_.ruleForm.children.length?JSON.stringify(this_.ruleForm.children):'';
					var datas = {
						// user_name: this_.ruleForm.user_name,
						// area_code: this_.ruleForm.prefix,
						tel: this_.ruleForm.tel,
						code: this_.ruleForm.code,
						password: this_.ruleForm.password,
						re_password: this_.ruleForm.re_password,
						email: this_.ruleForm.email,
						name: this_.ruleForm.name,
						province: this_.ruleForm.province,
						// tel: this_.ruleForm.tel,
						wechat_id: this_.ruleForm.wechat_id,
						referred_tel: this_.ruleForm.referred_tel,
						// time_zone: this_.ruleForm.time_zone,
						// time_country: this_.ruleForm.time_country,
						seller_id: this_.ruleForm.seller_id,
						children:children,
					};
					var url = "addUser";
					this_.$post(url, datas).then(res => {
						this_.$alert(this_.$t('index_register.successful'), this_.$t('header.tips'), {
							callback: action => {
								localStorage.setItem('TokenId', res.TokenId);
								localStorage.setItem('UserId', res.UserId);
								localStorage.setItem('user_name', this_.ruleForm.name);
								localStorage.setItem('type','user');
								this_.user_name_f();
								this_.$router.push('/');
							}
						});
					}).catch(res => {})
				} else {
					this_.$message.error(this_.$t('index_register.perfect'));
					console.log('error submit!!');
					return false;
				}
			});
		},
		email_verification(e){
			var this_ = this;
			var datas = {
				value: this_.ruleForm.email,
				table:'user',
				field:'email',
			}
			var url = "verifyUnique";
			this_.$refs.ruleForm.validateField('email',(valid) => {
				if (!valid) {
					this_.$post(url, datas,false).then(res => {
						
					}).catch(res => {})
				}else{
					return false;
				}
			});
		},	
		year_month_f(data,index){
			if (data) {
				this.ruleForm.children[index].birthday_year=data.split('-')[0];
				this.ruleForm.children[index].birthday_month=data.split('-')[1];
			}else{
				this.ruleForm.children[index].birthday_year='';
				this.ruleForm.children[index].birthday_month='';
			}
		},
		add(){
			var obj={
				name:'',
				name_cn:'',
				year_month:'',
				birthday_month:'',
				birthday_year:'',
				grade:'',
				password:'',
				user_name:'',
				is_adult:0,
			}
			this.ruleForm.children.push(obj);
		},
		remove(index){
			this.removeByIndex(this.ruleForm.children,index);
		},
		timer() {
			var time=this.time;
			var btntxt=this.btntxt;
			var disabled=this.disabled;
			if (time > 0) {
				time--;
				if (this.lang=='cn') {
					btntxt=time+"s后重新获取";
				}else{
					btntxt="After "+time+" seconds, it was retrieved";
				}
				disabled=true;
				setTimeout(this.timer, 1000);
			} else{
				time=0;
				btntxt=this.$t('index_register.phone_code');
				disabled=false;
			}
			this.time=time;
			this.disabled=disabled;
			this.btntxt=btntxt;
		},
	}
}
</script>
<style scoped>
.line i{
	font-size:34px;
	margin-top: 53px;
	padding-left: 20px;
	display: block;
	cursor: pointer;
}
.prefix{
	min-width: 120px;
}
.blue{
	color:#3cbddc;
	line-height: 30px;
}
.input_yincang{
	width: 0;
	height: 0;
	position: relative;
	overflow: hidden;
}
.input_yincang>div{
	position: absolute;left: 100px;
	top: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/web/index/register.vue